<template>
  <NodeViewWrapper class="button-node-view">
    <ButtonComponent :label="node.attrs.label" :icon="node.attrs.icon" :theme="node.attrs['data-cta']" @click.prevent />
  </NodeViewWrapper>
</template>

<script>
import { ButtonComponent } from 'vue-elder-button'
import { NodeViewWrapper, nodeViewProps } from '@kvass/rich-text'

export default {
  name: 'ButtonView',
  components: {
    NodeViewWrapper,
    ButtonComponent,
  },
  props: nodeViewProps,
}
</script>
